/** @format */

import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';

import { IOrchestratedList } from '@shared/favorites/data-access/interfaces';
import { LIST_CARD_IMAGE_UNAVAILABLE } from './image-unavailable.constant';
import { ListType } from '@my-account/list/enums';
import { Environment } from '@shared/data-access/interfaces';
import { WINDOW } from '@shared/data-access/services';

@Component({
	selector: 'my-account-list-components-list-card',
	templateUrl: './list-card.component.html',
	styleUrl: './list-card.component.scss',
	standalone: false
})
export class ListCardComponent {
	imageSrc = '';
	recommendedListDescription = '';

	@Input() list: IOrchestratedList = null;
	@Input() recommendedAnalyticsData = null;

	constructor(
		private router: Router,
		@Inject(WINDOW) protected window: Window,
		private environment: Environment
	) {}

	ngOnInit() {
		this.imageSrc = this.determineProductImageURL();
		this.recommendedListDescription =
			this.list.listType === ListType.RECOMMENDED
				? JSON.parse(sessionStorage.getItem('recommended_list')).list.description
				: '';
	}

	openListDetails() {
		let queryParams: any = { listID: this.list.id };

		if (this.list.listType === ListType.RECOMMENDED) {
			queryParams = { ...queryParams, ...this.recommendedAnalyticsData, recommended: 'true' };
		}

		const listDisplayName = this.list.displayName.replace('/', '_');

		this.router.navigate([`MyAccount/Lists/${listDisplayName}`], { queryParams: queryParams });
	}

	handleCardImageError(image) {
		image.target.src = LIST_CARD_IMAGE_UNAVAILABLE;
	}

	determineProductImageURL(): string {
		if (this.list.recentProduct) {
			if (!this.list.recentProduct?.fullImageURL) {
				return `${this.environment.thirdParty.scene7.url}${this.list.recentProduct?.imageIdentifier}_is/?wid=90&hei=90&qlt=85,0&fmt=jpg&op_sharpen=1`;
			} else {
				return `${this.list.recentProduct?.fullImageURL}?hei=90&wid=90&op_sharpen=1`;
			}
		} else if (this.list.listType === ListType.RECOMMENDED) {
			const recommendedListImageIdentifier = JSON.parse(
				sessionStorage.getItem('recommended_list')
			).list.products[0].productAttributes.imageIdentifier;
			return `${this.environment.thirdParty.scene7.url}${recommendedListImageIdentifier}_is/?wid=90&hei=90&qlt=85,0&fmt=jpg&op_sharpen=1`;
		}
		return LIST_CARD_IMAGE_UNAVAILABLE;
	}
}
